export default __webpack_public_path__ + "static/media/sachin_profile.c7071a32.jpg";